import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { ContactModalComponent } from '../contact/contact-modal/contact-modal.component';

declare function owlCarousel(): any;

@Component({
  selector: 'app-about-page',
  templateUrl: './about-page.component.html',
  styleUrls: ['./about-page.component.css']
})
export class AboutPageComponent implements OnInit {
  public teamMembers = [
    {
      id: 0,
      name: "Alan Del Angel",
      title: "Owner",
      image: "assets/img/team_thumb_1.jpg"
    },
    {
      id: 1,
      name: "Victoria Saengsavath",
      title: "bub <3",
      image: "assets/img/team_thumb_2.jpg"
    },
    {
      id: 2,
      name: "Roberto Del Angel",
      title: "Constructive Criticism",
      image: "assets/img/team_thumb_3.jpg"
    },
    {
      id: 3,
      name: "Jordi Alvarez",
      title: "Media Coordinator",
      image: "assets/img/team_thumb_4.jpg"
    }
  ];
  public carouselView = false;
  public customOptions: OwlOptions = {
    loop: true,
    center: true,
    margin: 40,
    nav: false,
    dots: false,
    smartSpeed: 1000,
    autoplay: true,
    autoplayTimeout: 4000,
    animateOut: 'slideOutDown',
    animateIn: 'flipInX',
    responsive: {
        0: {
            items: 1
        },
        576: {
            items: 2
        },
        768: {
            items: 2
        },
        992: {
            items: 3
        }
    }
  }
  constructor(private dialog: MatDialog) { }

  ngOnInit(): void {
  }

  
  openContactModal() {
    this.dialog.open(ContactModalComponent, {  
      data: {},
      width: 'fit-content',
      height: 'fit-content',
      panelClass: 'contact-modal'
    });
  }
}
